import { render } from "./Lora.vue?vue&type=template&id=4c1f0ecb&scoped=true"
import script from "./Lora.vue?vue&type=script&lang=js"
export * from "./Lora.vue?vue&type=script&lang=js"

import "./Lora.vue?vue&type=style&index=0&id=4c1f0ecb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1f0ecb"]])

export default __exports__